import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NotificationTableDto from '../dto/NotificationTableDto';

class NotificationTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'notificationTableControl';
	}

	/**
	* @param {string} session
	* @param {number} id
	*/
	userDeleteById(session, id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/userDeleteById`, { session, id, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	userDeleteAll() {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/userDeleteAll`, {})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<NotificationTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, { session, firstResult, maxResults })
				.then(response => resolve(new GenericTableDto().setup(response.data, NotificationTableDto)))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	*/
	markAsRead(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/markAsRead`, { id, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	*/
	markAsUnRead(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/markAsUnRead`, { id, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new NotificationTableService();